


















import GrpTagChoice from "@/interfaces/GrpTagChoice";
import { Component, Vue } from "vue-property-decorator";
import VCheckbox from "../VCheckbox.vue";

@Component({ components: { VCheckbox } })
export default class GenderPanel extends Vue {
  tagMap = {
    male: false,
    female: false,
  };

  onMaleInput(selected: boolean) {
    this.tagMap.male = selected;
    this.notify();
  }
  onFemaleInput(selected: boolean) {
    this.tagMap.female = selected;
    this.notify();
  }

  init(choice: GrpTagChoice | null) {
    const tags = choice?.tag as string[];
    this.tagMap.male = !!tags.find((t) => t == "male");
    this.tagMap.female = !!tags.find((t) => t == "female");
  }

  private notify() {
    const choice: GrpTagChoice = {
      tag: [],
      type: "list",
      isValid: false,
    };
    if (this.tagMap.male) {
      (choice.tag as string[]).push("male");
      choice.isValid = true;
    }
    if (this.tagMap.female) {
      (choice.tag as string[]).push("female");
      choice.isValid = true;
    }
    this.$emit("choice", choice);
  }
}
